import React from 'react'
import { Box, Grid, Skeleton, Typography } from '@mui/material'

const MarketPlaceHeaderSkeleton = () => {
  return (
    <Grid padding={2}>
      <Grid container>
        <Grid
          container
          item
          xs={12}
          display='flex'
          justifyContent='space-between'
          width='100%'
          gap={2}
          marginBottom={4}
        >
          <Box
            sx={{
              display: 'flex',
              flexDirection: 'column',
              flexGrow: 1,
              gap: 2,
            }}
          >
            <Typography sx={{ fontSize: '15px' }}>
              <Skeleton
                variant='text'
                width={100}
              />
            </Typography>
            <Box
              sx={{
                height: '50px',
                bgcolor: '#F4F4F4', // Light grey background
                borderRadius: '15px',
                display: 'flex',
                alignItems: 'center',
                padding: '25px',
              }}
              gap={2}
            >
              <Box
                width={'50px'}
                height={'50px'}
                display={'flex'}
                justifyContent={'center'}
                alignItems={'center'}
                borderRadius={'12px'}
                sx={{ bgcolor: '#F4F4F4' }} // Darker grey circle
              >
                <Skeleton
                  variant='circular'
                  width={40}
                  height={40}
                />
              </Box>
              <Box>
                <Typography
                  color={'#6267AC'}
                  variant='h5'
                  fontWeight={'bold'}
                >
                  <Skeleton
                    variant='text'
                    width={100}
                  />
                </Typography>
                <Typography
                  variant='body2'
                  fontWeight={'light'}
                >
                  <Skeleton
                    variant='text'
                    width={150}
                  />
                </Typography>
              </Box>
            </Box>
          </Box>
          <Box
            sx={{
              display: 'flex',
              flexDirection: 'column',
              flexGrow: 1,
              gap: 2,
            }}
          >
            <Typography sx={{ fontSize: '15px' }}>
              <Skeleton
                variant='text'
                width={100}
              />
            </Typography>
            <Box
              sx={{
                height: '50px',
                bgcolor: '#F4F4F4', // Light grey background
                borderRadius: '15px',
                display: 'flex',
                alignItems: 'center',
                padding: '25px',
              }}
              gap={2}
            >
              <Box
                width={'50px'}
                height={'50px'}
                display={'flex'}
                justifyContent={'center'}
                alignItems={'center'}
                borderRadius={'12px'}
                sx={{ bgcolor: '#F4F4F4' }} // Darker grey circle
              >
                <Skeleton
                  variant='circular'
                  width={40}
                  height={40}
                />
              </Box>
              <Box>
                <Typography
                  color={'#6267AC'}
                  variant='h5'
                  fontWeight={'bold'}
                >
                  <Skeleton
                    variant='text'
                    width={100}
                  />
                </Typography>
                <Typography
                  variant='body2'
                  fontWeight={'light'}
                >
                  <Skeleton
                    variant='text'
                    width={150}
                  />
                </Typography>
              </Box>
            </Box>
          </Box>
        </Grid>
      </Grid>

      <Box
        sx={{
          bgcolor: 'white',
          padding: 4,
          display: 'flex',
          flexDirection: 'column',
          borderRadius: '20px',
          border: '1px solid #EEEEEE',
        }}
      >
        {/* Skeleton for Image Uploader */}
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'center',
            marginBottom: '20px',
          }}
        >
          <Skeleton
            variant='circular'
            width={150}
            height={150}
          />
        </Box>
        {/* Skeleton for Text Fields */}
        <Grid
          container
          spacing={2}
          marginBottom={2}
        >
          <Grid
            item
            xs={6}
          >
            <Skeleton
              variant='text'
              width={'100%'}
              height={80}
            />
          </Grid>
          <Grid
            item
            xs={6}
          >
            <Skeleton
              variant='text'
              width={'100%'}
              height={80}
            />
          </Grid>
          <Grid
            item
            xs={6}
          >
            <Skeleton
              variant='text'
              width={'100%'}
              height={80}
            />
          </Grid>
          <Grid
            item
            xs={6}
          >
            <Skeleton
              variant='text'
              width={'100%'}
              height={80}
            />
          </Grid>
        </Grid>
        {/* Skeleton for Buttons */}
        <Grid
          container
          justifyContent='flex-end'
          spacing={2}
        >
          <Grid item>
            <Skeleton
              variant='rectangular'
              width={100}
              height={40}
            />
          </Grid>
          <Grid item>
            <Skeleton
              variant='rectangular'
              width={100}
              height={40}
            />
          </Grid>
        </Grid>
      </Box>
    </Grid>
  )
}

export default MarketPlaceHeaderSkeleton
